const viewNames = [
  'stores',
  'centerCusts',
  'suppliers',
  'staffers',
  'products',
  'productsA',
  'productsB',
  'productsC',
  'productsD',
  'productsE',
  'productsF',
]

const views = { }
viewNames.forEach(name => {
  views[name] = require(`./${name}.js`)
})

module.exports = views



// WEBPACK FOOTER //
// ./src/views/index.js